import type { TFunction } from "i18next";
import type { U2000DeleteHandlersReturn } from "../../../u2000Core/hooks/handler/U2000UseDeleteHandlers";
import U2000DeleteRecordDialog from "../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3129Timesheet } from "../../U3129Service";

interface U3129TimesheetDeleteDlgProps {
  handleDelete: U2000DeleteHandlersReturn<U3129Timesheet>;
  t: TFunction;
  NS: string;
}

function U3129TimesheetDeleteDlg({ handleDelete, t, NS }: U3129TimesheetDeleteDlgProps) {
  if (!handleDelete.isDialogDeleteOpen) return null;

  return (
    <U2000DeleteRecordDialog
      isOpen={handleDelete.isDialogDeleteOpen}
      onClose={handleDelete.handleDeleteCloseDlg}
      title={t("lblDeleteDlgTitle", { ns: NS, defaultValue: "Suppression" })}
    >
      <p className="mb-4">
        {t("msgDeleteLogicalUnit", {
          ns: NS,
          count: handleDelete.selectedRows().length,
          defaultValue: "Voulez-vous supprimer cet enregistrement ?",
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {handleDelete.selectedRows().map((row, index, array) => {
          const label = row.periodDisplay?.trim() || row.periodDate?.trim() || row.id || "—";
          return (
            <span key={`${row.id || "row"}-${index}`} className="inline-block text-gray-800">
              {label}
              {index < array.length - 1 && ", "}
            </span>
          );
        })}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3129TimesheetDeleteDlg;
